import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { translateError } from '../utils/errorMessages';
import { Avatar, type StaffProfile } from './StaffProfiles';

export default function StaffProfileFields({ value, onChange, onBusy, disabled = false }: {
  value: StaffProfile; onChange: (value: StaffProfile) => void; onBusy: (busy: boolean) => void; disabled?: boolean;
}) {
  const { t } = useTranslation();
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);
  const upload = async (file?: File) => {
    if (!file) return;
    setError('');
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 2 * 1024 * 1024) {
      setError(t('staffProfile.photoHint')); return;
    }
    setUploading(true); onBusy(true);
    try { const { data } = await api.uploads.upload('staff-photo', file); onChange({ ...value, photoUrl: data.url }); }
    catch (err) { setError(translateError(err, t)); }
    finally { setUploading(false); onBusy(false); }
  };
  return <div className="staff-profile-fields">
    <p>{t('staffProfile.visibility')}</p>
    <div className="staff-profile-fields__photo">
      <Avatar person={{ name: '?', photoUrl: value.photoUrl }} />
      <label>{t('staffProfile.photo')}<input type="file" accept="image/png,image/jpeg,image/webp" disabled={disabled || uploading} onChange={e => { void upload(e.target.files?.[0]); e.target.value = ''; }} /></label>
      {value.photoUrl && <button type="button" disabled={disabled || uploading} onClick={() => onChange({ ...value, photoUrl: null })}>{t('staffProfile.removePhoto')}</button>}
    </div>
    <small>{uploading ? t('common.loading') : t('staffProfile.photoHint')}</small>
    {error && <p className="error-message" role="alert">{error}</p>}
    <label>{t('staffProfile.aboutMe')}<textarea value={value.aboutMe} maxLength={2000} disabled={disabled || uploading} onChange={e => onChange({ ...value, aboutMe: e.target.value })} /></label>
    <small>{value.aboutMe.length} / 2000</small>
  </div>;
}
